import { PaymentResultType } from "@/stores/EngineStore/enums/PaymentResultType.ts";

/**
 * Normalizes the `paymentResult` URL param set by the payment backend on redirect back.
 * The backend sends `success`, `error` or `cancel` (not `cancellation`).
 */
export const parsePaymentResult = (raw: string | null): PaymentResultType | null => {
  switch (raw?.toLowerCase()) {
    case "success":
      return PaymentResultType.Success;
    case "error":
      return PaymentResultType.Error;
    case "cancel":
    case "cancellation":
      return PaymentResultType.Cancellation;
    default:
      return null;
  }
};
